// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2_PJO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1m3OH"};